import SchoolImage1 from "../../../../assets/images/png/individual/school1.webp";
import SchoolImage2 from "../../../../assets/images/png/individual/school2.webp";
import SchoolImage3 from "../../../../assets/images/png/individual/school3.webp";
import SchoolImage4 from "../../../../assets/images/png/individual/school4.webp";
import SchoolImage5 from "../../../../assets/images/png/individual/school5.webp";
import SchoolImage6 from "../../../../assets/images/png/individual/school6.webp";
import SchoolImage7 from "../../../../assets/images/png/individual/school7.webp";
import SchoolImage8 from "../../../../assets/images/png/individual/school8.webp";

const kickStartDataAfrica = [
  {
    id: 1,
    title: (
      <>
        I am interested in <strong>Data</strong> and <strong>numbers</strong>
      </>
    ),
    image: SchoolImage1,
    url: "/school/data-school",
    bgColor: "#050794",
  },
  {
    id: 2,
    title: (
      <>
        I am interested in <strong>Design</strong> and{" "}
        <strong>Creatives</strong>
      </>
    ),
    image: SchoolImage2,
    url: "/courses/product-management-and-design-bootcamp",
    bgColor: "#0C8F54",
  },
  {
    id: 3,
    title: (
      <>
        I am interested in <strong>Products</strong>
      </>
    ),
    image: SchoolImage3,
    url: "/courses/product-management-and-design-bootcamp",
    bgColor: "#7C01A7",
  },
  {
    id: 4,
    title: (
      <>
        I am interested in <strong>Business Analysis</strong>
      </>
    ),
    image: SchoolImage4,
    url: "/courses/business-analysis-bootcamp",
    bgColor: "#A78700",
  },
  {
    id: 5,
    title: (
      <>
        I am interested in <strong>Project Management</strong>
      </>
    ),
    image: SchoolImage7,
    url: "/courses/business-analysis-bootcamp",
    bgColor: "#0E8F8F",
  },
  {
    id: 6,
    title: (
      <>
        I am interested in <strong>Programming</strong>
      </>
    ),
    image: SchoolImage5,
    url: "/school/programming-school",
    bgColor: "#A74F46",
  },
  {
    id: 7,
    title: (
      <>
        I am interested in <strong>Cloud Development</strong>
      </>
    ),
    image: SchoolImage6,
    url: "/courses/cloud-bootcamp",
    bgColor: "#0E8F8F",
  },
  {
    id: 8,
    title: (
      <>
        I am interested in <strong>Product Marketing</strong>
      </>
    ),
    image: SchoolImage7,
    url: "/courses/product-marketing-bootcamp",
    bgColor: "#10A662",
  },
  {
    id: 9,
    title: (
      <>
        I am interested in <strong>Technology Sales</strong>
      </>
    ),
    image: SchoolImage8,
    url: "/courses/tech-sales-bootcamp",
    bgColor: "#000269",
  },
  {
    id: 10,
    title: (
      <>
        I am interested in <strong>Cybersecurity</strong>
      </>
    ),
    image: SchoolImage3,
    url: "/courses/cybersecurity-bootcamp",
    bgColor: "#A78700",
  },
  {
    id: 11,
    title: (
      <>
        I am interested in <strong>HR Analytics</strong>
      </>
    ),
    image: SchoolImage5,
    url: "/courses/hr-analytics",
    bgColor: "#000F44",
  },
  {
    id: 12,
    title: (
      <>
        I am interested in <strong>AI Automation</strong>
      </>
    ),
    image: SchoolImage1,
    url: "/courses/ai-automation-diploma",
    bgColor: "#34A354",
  },
  {
    id: 13,
    title: (
      <>
        I am interested in <strong>MBA</strong>
      </>
    ),
    image: SchoolImage4,
    url: "/mba",
    bgColor: "#050794",
  },
];

export default kickStartDataAfrica;
